import { memo } from 'react';
import { useParams } from 'react-router-dom';
import PageTitle from '@/shared/components/PageTitle';
import Editor from '@/shared/components/Editor';
import { Skeleton } from '@/shared/components/ui/skeleton';
import { usePublicCollectionNote } from '../hooks/usePublicCollectionNote';

const SharedCollectionNote = () => {
  const { collectionId, pageId } = useParams<{ collectionId: string; pageId: string }>();
  const { data: page, isError, isLoading } = usePublicCollectionNote(pageId, collectionId);

  if (isError || !pageId) {
    return <div>Error</div>;
  }

  // If loading is still happening after the delay, show skeleton
  if (isLoading) {
    return (
      <div className="animate-fadeIn px-4 md:px-10 lg:px-0 xl:-ml-8">
        <div className="mx-auto md:max-w-3xl">
          {/* Page title skeleton */}
          <div className="mb-8">
            <Skeleton className="bg-accent h-10 w-2/3 mb-2" />
          </div>

          {/* Content skeleton - 3 lines */}
          <div className="space-y-4">
            <Skeleton className="bg-accent h-4 w-11/12" />
            <Skeleton className="bg-accent h-4 w-full" />
            <Skeleton className="bg-accent h-4 w-5/6" />
          </div>
        </div>
      </div>
    );
  }

  if (page?.id) {
    return (
      <div>
        <div className="overflow-y-auto overflow-x-hidden">
          <div className="mx-auto md:max-w-3xl lg:max-w-4xl px-1.5 md:px-8">
            <PageTitle page={page} showTag={false} enableEditing={false} />
            <div className="pt-2">
              <Editor key={pageId} page={page} enableEditing={false} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-[75%] flex flex-col items-center justify-center">
      <div className="flex-col space-y-4 text-center">
        <div className="text-3xl text-muted-foreground">¯/_(ツ)_/¯</div>
        <div className="text-xl text-muted-foreground">No notes found here</div>
      </div>
    </div>
  );
};

export default memo(SharedCollectionNote);
